const styles = {
  container: {
    marginBottom: '50px'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  button: {
    marginLeft: '10px',
    '& svg': {
      marginRight: '4px'
    }
  },
  sharedButton: {
    marginLeft: '10px',
    background: '#dcdcdc !important',
    color: '#fff',
    fontWeight: 'bold',
    padding: '10px',
    borderRadius: '100%',
    height: '25px',
    width: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      color: '#fff',
      background: '#c8c5c5 !important'
    }
  }
}

export default styles
